<template>
  <div class="container py-4">
    <h2 class="mb-3 text-white">Device List</h2>
    <table class="table table-dark table-bordered table-hover">
      <thead>
        <tr>
          <th>#</th>
          <th>Device Name</th>
          <th>Status</th>
          <th>Control</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(device, index) in devices" :key="device.id">
          <td>{{ index + 1 }}</td>
          <td>{{ device.thingName }}</td>
          <td>
            <span :class="device.connected ? 'text-success' : 'text-danger'">
              {{ device.connected ? 'Online' : 'Offline' }}
            </span>
          </td>
          <td>
            <button
              class="btn btn-sm me-2 btn-success"
              :disabled="!device.connected"
              @click="resumeDevice(device)"
            >
              Resume
            </button>
            <button
              class="btn btn-sm me-2 btn-danger"
              :disabled="!device.connected"
              @click="pauseDevice(device)"
            >
              Pause
            </button>

          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { onMounted, ref, getCurrentInstance } from 'vue'

const { appContext } = getCurrentInstance();
const APP_ID = ref("");
APP_ID.value = appContext.config.globalProperties.$APP_ID;

const devices = ref([])

async function fetchDevices() {
  const secretId = appContext.config.globalProperties.$USER.secretId;
  const secretKey = appContext.config.globalProperties.$USER.secretKey;
  const url = '/api/v1/ufb/humanoid?service=ufb'
  // secret id and key as basic auth
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Basic ${btoa(`${secretId}:${secretKey}`)}`,
    },
  });
  if (!response.ok) {
    throw new Error('Failed to fetch data');
  }
  const data = await response.json();
  devices.value = data || [];
  console.log('Devices fetched:', devices.value);
}

onMounted(() => {
  fetchDevices()
})

function resumeDevice(device) {
  const url = '/api/v1/ufb/humanoid/request/' + device.thingName + '?service=ufb&request=resume';
  const secretId = appContext.config.globalProperties.$USER.secretId;
  const secretKey = appContext.config.globalProperties.$USER.secretKey;
  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Basic ${btoa(`${secretId}:${secretKey}`)}`,
    },
  }).then(() => {
    alert(`Resumed device: ${device.thingName}`);
  }).catch(error => {
    console.error(`Error resuming device: ${device.thingName}`, error);
  })
}

function pauseDevice(device) {
  const url = '/api/v1/ufb/humanoid/request/' + device.thingName + '?service=ufb&request=pause';
  const secretId = appContext.config.globalProperties.$USER.secretId;
  const secretKey = appContext.config.globalProperties.$USER.secretKey;
  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Basic ${btoa(`${secretId}:${secretKey}`)}`,
    },
  }).then(() => {
    alert(`Paused device: ${device.thingName}`);
  }).catch(error => {
    console.error(`Error pausing device: ${device.thingName}`, error);
  });
}

</script>

